import type { CalibrationKind, Drone } from '../../types';
import { formatCalibration } from '../formatCalibration';

type CalibrationLabels = {
    daysAgoSuffix: string;
    flow: string;
    level: string;
    magnetometer: string;
    neverText: string;
    pump: string;
    weight: string;
};

export type CalibrationMetric = { label: string; value: string };

export const getCalibrationMetrics = ({
    drone,
    labels
}: {
    drone: Drone;
    labels: CalibrationLabels;
}): CalibrationMetric[] => {
    const calibrate = (kind: CalibrationKind): string =>
        formatCalibration({
            daysAgoSuffix: labels.daysAgoSuffix,
            neverText: labels.neverText,
            recency: drone.calibration[kind]
        });

    return [
        { label: labels.pump, value: calibrate('pump') },
        { label: labels.flow, value: calibrate('flow') },
        { label: labels.weight, value: calibrate('weight') },
        { label: labels.magnetometer, value: calibrate('magnetometer') },
        { label: labels.level, value: calibrate('level') }
    ];
};
